import React from "react";
import {
  Page,
  View,
  Image,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

// Font registration
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 0,
    position: "relative",
    fontFamily: "Roboto",
  },
  container: {
    height: "100%",
    minHeight: "100vh",
    paddingHorizontal: 30,
    justifyContent: "center",
    alignItems: "flex-start",
    position: "relative",
    paddingTop: 250,
    paddingLeft: 100,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -10,
    right: 0,
    width: 300,
  },
  logo: {
    width: 220,
    position: "absolute",
    bottom: 420,
    right: 230,
  },
  navigation: {
    position: "absolute",
    top: 30,
    right: 0,
    width: 400,
  },
});

// PDF EndingPage Component
const EndingPagePDF = ({ assets }) => (
  <Page size="A4" style={styles.page}>
    <View style={styles.container}>
      {/* Logo */}
      <Image src={assets.logo} style={styles.logo} />
      <Image src={assets.lower} style={styles.lowerDesign} fixed />
      <Image src={assets.navigation} style={styles.navigation} />
    </View>
  </Page>
);

export default EndingPagePDF;
